var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgInscrito = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30915 4.62946C9.30915 4.7433 9.26897 4.85045 9.18862 4.9308L5.55246 8.56696C5.4721 8.64732 5.35826 8.6942 5.24442 8.6942C5.13728 8.6942 5.02344 8.64732 4.94308 8.56696L2.51897 6.14286C2.43862 6.0625 2.39844 5.95536 2.39844 5.84152C2.39844 5.72768 2.43862 5.61384 2.51897 5.53348L3.12835 4.9308C3.20871 4.85045 3.31585 4.80357 3.42969 4.80357C3.54353 4.80357 3.65067 4.85045 3.73103 4.9308L5.24442 6.4442L7.97656 3.71875C8.05692 3.63839 8.16406 3.59152 8.2779 3.59152C8.39174 3.59152 8.49888 3.63839 8.57924 3.71875L9.18862 4.32143C9.26897 4.40179 9.30915 4.51562 9.30915 4.62946ZM10.9967 5.71429C10.9967 2.875 8.69308 0.571428 5.8538 0.571428C3.01451 0.571428 0.710938 2.875 0.710938 5.71429C0.710938 8.55357 3.01451 10.8571 5.8538 10.8571C8.69308 10.8571 10.9967 8.55357 10.9967 5.71429Z",
    fill: "#333333"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInscrito, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/inscrito.24fbfaa4.svg";
export { ForwardRef as ReactComponent };